import {Component, OnInit, Input, OnChanges} from '@angular/core';
import {WizardWidgetComponent} from '../wizard-widget/wizard-widget.component';
import {ProductService, RateService} from '../../../services';
import {DataHandlerService} from '../../../services/data-handler.service';
import { MatInputModule } from '@angular/material/input';
import { ValidationPartialComponent } from '../partials/validation-partial.component';
import { MatOptionModule } from '@angular/material/core';
import { NgFor } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';

@Component({
    selector: 'app-balloon-amount',
    templateUrl: './balloon-amount.component.html',
    styles: [],
    standalone: true,
    imports: [MatCardModule, MatCardModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatFormFieldModule, MatSelectModule, MatSelectModule, NgFor, MatOptionModule, MatOptionModule, ValidationPartialComponent, MatInputModule, MatInputModule]
})
export class BalloonAmountComponent extends WizardWidgetComponent implements OnInit, OnChanges {
  @Input() public loanPurposeType: any;
  @Input() public currentPurchaseAmount: any;
  @Input() public loanPurpose: any;
  @Input() public loanTerm: any;
  @Input() public autoCollateral: any;
  @Input() public selectedVehicle: any;

  public allBalloons = [];
  public disableBalloons = true;
  private _loanPurpose: any;
  private _loanTerm: any;
  private _autoCollateral: any;
  private _productType: any;
  private _purchaseAmount = 0;

  constructor(public dataHandlerService: DataHandlerService,
              private productService: ProductService,
              private rateService: RateService) {
    super(dataHandlerService);
  }

  ngOnInit() {
    super.ngOnInit();

    if (this.loanPurposeType === 'motor-vehicle-loan') {
      this._productType = 'motor-vehicle';
    }

    console.log('selectedVehicle', this.selectedVehicle);
  }

  ngOnChanges(changes) {
    if (changes['currentPurchaseAmount']) {
      this._purchaseAmount = changes['currentPurchaseAmount']['currentValue'];
      this.calculateBalloon();
    }

    if (changes['loanPurpose']) {
      this._loanPurpose = changes['loanPurpose']['currentValue'];
      this.populateBalloons();
    }

    if (changes['loanTerm']) {
      this._loanTerm = changes['loanTerm']['currentValue'];
      this.populateBalloons();
    }

    if (changes['autoCollateral']) {
      this._autoCollateral = changes['autoCollateral']['currentValue'];
      this.populateBalloons();
    }
  }

  public calculateBalloon() {
    console.log('[calculateBalloon]');
    const value = +(Number(this._purchaseAmount) * (Number(this.formGroup.get('balloonPercentage').value) / 100)).toFixed(2);
    this.formGroup.get('amount').patchValue(value.toString());
    this.rateService.setRateParameters({balloonAmount: value});
  }

  public populateBalloons() {
    if (this._loanPurpose && this._loanTerm && this._autoCollateral) {

      this.productService.getBalloons(this._productType, this._loanPurpose, this._autoCollateral.year, this._loanTerm.rate.term.value)
        .subscribe((results: any) => {
          this.allBalloons = [];
          if (results) {
            this.allBalloons = results;
            this.disableBalloons = false;
            // if currently selected balloon is no longer allowed
            if (results.indexOf(this.formGroup.get('balloonPercentage').value) === -1) {
              this.formGroup.get('balloonPercentage').setValue(null, {emitEvent: false});
            }
          } else {
            // defaults to 0
            this.allBalloons.push(0);
            this.formGroup.get('balloonPercentage').setValue(0, {emitEvent: false});
            this.disableBalloons = false;
          }
        });
    }
  }
}
